import React, { useState, useEffect } from 'react';
import './EditPostModal.css';

const EditPostModal = ({ post, onClose, onSave }) => {
  const [caption, setCaption] = useState('');
  const [hashtags, setHashtags] = useState([]);
  const [hashtagInput, setHashtagInput] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (post) {
      setCaption(post.caption || '');
      setHashtags(post.hashtags || []);
    }
  }, [post]);

  const handleAddHashtag = (e) => {
    e.preventDefault();
    const tag = hashtagInput.trim();
    
    if (tag && !hashtags.includes(tag)) {
      // '#' 제거
      const cleanTag = tag.startsWith('#') ? tag.substring(1) : tag;
      if (cleanTag) {
        setHashtags([...hashtags, cleanTag]);
        setHashtagInput('');
      }
    }
  };

  const handleRemoveHashtag = (tagToRemove) => {
    setHashtags(hashtags.filter(tag => tag !== tagToRemove));
  };

  const handleHashtagInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddHashtag(e);
    } else if (e.key === 'Backspace' && !hashtagInput && hashtags.length > 0) {
      // 입력이 비어있고 백스페이스를 누르면 마지막 해시태그 삭제
      setHashtags(hashtags.slice(0, -1));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      await onSave({
        caption,
        hashtags,
      });
      onClose();
    } catch (error) {
      console.error('게시글 수정 실패:', error);
      alert('게시글 수정에 실패했습니다.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>게시글 수정</h2>
          <button className="close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18" strokeWidth="2" strokeLinecap="round"/>
              <line x1="6" y1="6" x2="18" y2="18" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="caption">설명</label>
            <textarea
              id="caption"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              placeholder="설명을 입력하세요..."
              rows="4"
            />
          </div>

          <div className="form-group">
            <label htmlFor="hashtags">해시태그</label>
            <div className="hashtag-input-container">
              {hashtags.map((tag, index) => (
                <div key={index} className="hashtag-tag">
                  #{tag}
                  <button
                    type="button"
                    className="hashtag-remove"
                    onClick={() => handleRemoveHashtag(tag)}
                  >
                    ×
                  </button>
                </div>
              ))}
              <input
                type="text"
                id="hashtags"
                value={hashtagInput}
                onChange={(e) => setHashtagInput(e.target.value)}
                onKeyDown={handleHashtagInputKeyDown}
                placeholder="해시태그 입력 후 Enter"
                className="hashtag-input"
              />
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              취소
            </button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? '저장 중...' : '저장'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPostModal;








